import { Button, Modal } from "antd";
import type { DashboardLayoutGuardModalProps } from "./types";

export function DashboardLayoutGuardModal({
  open,
  onCancel,
  onDiscard,
  onSave,
}: DashboardLayoutGuardModalProps) {
  return (
    <Modal
      open={open}
      title="Unsaved dashboard layout"
      closable={false}
      mask={{ closable: false }}
      keyboard={false}
      onCancel={onCancel}
      footer={
        <div className="flex items-center justify-between gap-2">
          <Button danger onClick={onDiscard}>
            Discard changes
          </Button>
          <div className="flex items-center gap-2">
            <Button onClick={onCancel}>Keep editing</Button>
            <Button type="primary" onClick={onSave}>
              Save and continue
            </Button>
          </div>
        </div>
      }
    >
      <p>
        Save your plot positions and sizes before leaving, or discard the layout
        changes you made in this editing session.
      </p>
    </Modal>
  );
}
